import React, {Component} from 'react';

import {Admin, Resource, usePermissions} from 'react-admin';
import './FrameworkApp.css';
import FrameworkAppLayout from './FrameworkAppLayout';
import FrameworkAppContext from "./FrameworkAppContext";
import CustomAppResources from "../custom/CustomAppResources";
import FrameworkAuthCheck from "./FrameworkAuthCheck";

const checkAuth = (resource, actionType, permissions) => {
    return FrameworkAuthCheck(resource, actionType, permissions);
}



const FrameworkApp = (props) => {


    console.log("FrameworkApp Initializing", {props});
    console.log('Node env is ' + process.env.NODE_ENV)
    const AppResources = CustomAppResources;

    const customSagas = [];
    const customReducers = [];

    AppResources.RESOURCES.forEach(resource => {
        if (resource.customSagas) {
            customSagas.push(resource.customSagas);
        }
        if (resource.customReducers) {
            customReducers.push(resource.customReducers);
        }

    });

    return (
        <FrameworkAppContext.Provider value={CustomAppResources}>
            <Admin dataProvider={AppResources.dataProvider}
                   authProvider={AppResources.authProvider}
                   layout={FrameworkAppLayout}
                   dashboard={AppResources.dashboard}
                   customRoutes={AppResources.customRoutes}
                   i18nProvider={AppResources.i18nProvider}
                   customSagas={customSagas}
                   customReducers={customReducers}
                   title={AppResources.title}
                   {...props}
            >
                {permissions => {

                    const resourceElements = [];

                    AppResources.RESOURCES.forEach(resource => {
                        if (!resource.disabled) {

                            var listAuth = checkAuth(resource, 'LIST', permissions);
                            var editAuth = checkAuth(resource, 'EDIT', permissions);
                            var createAuth = checkAuth(resource, 'CREATE', permissions);
                            var showAuth = checkAuth(resource, 'SHOW', permissions);

                            // For passing down to the menu...
                            AppResources.permissions = permissions;

                            /////////////////////////////////////////////
                            // Add the resource elements
                            /////////////////////////////////////////////
                            resourceElements.push((
                                <Resource key={resource['RESOURCE']}
                                          name={resource['RESOURCE']}
                                          icon={resource['ICON']}
                                          list={!listAuth ? null : resource['LIST']}
                                          edit={!editAuth ? null : resource['EDIT']}
                                          create={!createAuth ? null : resource['CREATE']}
                                          show={!showAuth ? null : resource['SHOW']}/>));
                        }
                    });

                    return resourceElements;
                }}
            </Admin>
        </FrameworkAppContext.Provider>
    )
}

export default React.memo(FrameworkApp);